// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__1bp6W","outline":"button_outline__D4DNA"};